import { useUser } from "shared-ts-utils-authentication";
import { useAppInfo } from "shared-ts-app-info";

export const useTaskPlanningPageEnabled = (): boolean => {
  const appInfo = useAppInfo();
  const user = useUser();
  return (
    appInfo.buildVersion === "local-development" || user.isAirmontEmployee()
  );
};
